// import React, { useState } from 'react';
// import axios from 'axios';
// import { useNavigate, Link } from 'react-router-dom';
// import logo from "../assets/WhatsApp Image 2025-12-05 at 13.19.29_68ae0406.jpg"
// export default function Signup() {
//   const [name, setName] = useState('');
//   const [email, setEmail] = useState('');
//   const [password, setPassword] = useState('');
//   const navigate = useNavigate();

//   const submit = async (e) => {
//     e.preventDefault();
//     try {
//       await axios.post('https://grocerrybackend.vercel.app/api/admin/register', { name, email, password });
//       alert('Admin registered successfully. Please login.');
//       navigate('/login');
//     } catch (err) {
//       console.error(err);
//       alert(err.response?.data?.message || 'Signup failed — check server logs');
//     }
//   };

//   return (
//     <div className="container py-5">
//       <div className="row justify-content-center">
//         <div className="col-md-5 col-lg-4">
//           <div className="card p-4 shadow-sm">
//             <h4 className="mb-3 text-center">Admin Signup</h4>
//             <form onSubmit={submit}>
//               <input
//                 className="form-control mb-2"
//                 placeholder="Name"
//                 value={name}
//                 onChange={(e) => setName(e.target.value)}
//                 required
//               />
//               <input
//                 type="email"
//                 className="form-control mb-2"
//                 placeholder="Email"
//                 value={email}
//                 onChange={(e) => setEmail(e.target.value)}
//                 required
//               />
//               <input
//                 type="password"
//                 className="form-control mb-3"
//                 placeholder="Password"
//                 value={password}
//                 onChange={(e) => setPassword(e.target.value)}
//                 required
//               />
//               <button className="btn btn-success w-100">Signup</button>
//             </form>
//             <div className="text-center mt-3">
//               <small>
//                 Already have an account? <Link to="/login">Login</Link>
//               </small>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }

// import React, { useState } from "react";
// import axios from "axios";
// import { useNavigate, Link } from "react-router-dom";
// import "./Signup.css";
// import signupImg from "../assets/WhatsApp Image 2025-12-05 at 13.19.29_68ae0406.jpg";

// export default function Signup() {
//   const [name, setName] = useState("");
//   const [email, setEmail] = useState("");
//   const [password, setPassword] = useState("");
//   const navigate = useNavigate();

//   const submit = async (e) => {
//     e.preventDefault();
//     try {
//       await axios.post("https://grocerrybackend.vercel.app/api/admin/register", {
//         name,
//         email,
//         password,
//       });

//       alert("Admin registered successfully. Please login.");
//       navigate("/login");
//     } catch (err) {
//       alert(err.response?.data?.message || "Signup failed");
//     }
//   };

//   return (
//     <div className="signup-wrapper">
//       {/* LEFT IMAGE */}
//       <div className="signup-left">
//         <img src={signupImg} alt="Signup Visual" className="signup-image" />
//       </div>

//       {/* RIGHT FORM */}
//       <div className="signup-right">
//         <div className="signup-box">
//           <h2 className="signup-title">Create Admin Account</h2>
//           <p className="signup-subtitle">Register to get started</p>

//           <form onSubmit={submit} className="signup-form">

//             <div className="input-group">
//               <label>Name</label>
//               <input
//                 type="text"
//                 placeholder="Enter full name"
//                 value={name}
//                 onChange={(e) => setName(e.target.value)}
//                 required
//               />
//             </div>

//             <div className="input-group">
//               <label>Email</label>
//               <input
//                 type="email"
//                 placeholder="Enter admin email"
//                 value={email}
//                 onChange={(e) => setEmail(e.target.value)}
//                 required
//               />
//             </div>

//             <div className="input-group">
//               <label>Password</label>
//               <input
//                 type="password"
//                 placeholder="Choose password"
//                 value={password}
//                 onChange={(e) => setPassword(e.target.value)}
//                 required
//               />
//             </div>

//             <button className="signup-btn">Signup</button>
//           </form>

//           <p className="login-text">
//             Already have an account? <Link to="/login">Login</Link>
//           </p>
//         </div>
//       </div>
//     </div>
//   );
// }







// import React, { useState } from "react";
// import axios from "axios";
// import { useNavigate, Link } from "react-router-dom";
// // import signupImg from "../assets/WhatsApp Image 2025-12-05 at 13.19.29_68ae0406.jpg";
// import logo from "../assets/logo.png";

// export default function Signup() {
//   const [name, setName] = useState("");
//   const [email, setEmail] = useState("");
//   const [password, setPassword] = useState("");
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState("");
//   const [showPassword, setShowPassword] = useState(false);
//   const navigate = useNavigate();

//   const submit = async (e) => {
//     e.preventDefault();
//     setError("");
//     setLoading(true);
    
//     try {
//       await axios.post("https://grocerrybackend.vercel.app/api/admin/register", {
//         name,
//         email,
//         password,
//       });

//       alert("Admin registered successfully. Please login.");
//       navigate("/login");
//     } catch (err) {
//       setError(err.response?.data?.message || "Signup failed — check server logs");
//       console.error(err);
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <div className="h-screen w-screen flex items-center justify-center p-4 bg-gradient-to-br from-blue-50 via-white to-gray-50 font-sans overflow-hidden">
//       {/* Main Container - Wider for side-by-side layout */}
//       <div className="w-full max-w-2xl mx-auto">
        
//         {/* Logo Header */}
//         <div className="flex flex-col items-center justify-center mb-6">
//           <div className="w-16 h-16 rounded-full bg-white shadow-lg flex items-center justify-center p-1 mb-3 ring-2 ring-blue-100">
//             <img 
//               src={logo} 
//               alt="GrocerryAdmin Logo" 
//               className="w-full h-full object-cover rounded-full"
//             />
//           </div>
//           <h1 className="text-xl font-bold text-gray-900 text-center">SG Overseas Admin</h1>
//           <p className="text-gray-600 text-sm mt-1 text-center">Admin Portal</p>
//         </div>

//         {/* Wider Signup Card for side-by-side layout */}
//         <div className="bg-white rounded-xl shadow-lg p-6 border border-gray-100">
          
//           {/* Form Header */}
//           <div className="text-center mb-6">
//             <h2 className="text-lg font-bold text-gray-900">Create Admin Account</h2>
//             <p className="text-gray-600 text-xs mt-1">Register to get started</p>
//           </div>

//           {/* Error Message */}
//           {error && (
//             <div className="mb-5 p-3 bg-red-50 border border-red-200 rounded-lg animate-fadeIn">
//               <div className="flex items-center">
//                 <svg className="w-4 h-4 text-red-600 mr-2 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                   <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
//                 </svg>
//                 <span className="text-red-800 text-xs font-medium">{error}</span>
//               </div>
//             </div>
//           )}

//           {/* Signup Form with side-by-side fields */}
//           <form onSubmit={submit} className="space-y-5">
            
//             {/* Name and Email Fields - Side by Side */}
//             <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
//               {/* Name Field */}
//               <div>
//                 <label className="block text-xs font-semibold text-gray-700 mb-1">
//                   Full Name
//                 </label>
//                 <div className="relative">
//                   <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
//                     <svg className="h-4 w-4 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                       <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
//                     </svg>
//                   </div>
//                   <input
//                     type="text"
//                     placeholder="Enter full name"
//                     value={name}
//                     onChange={(e) => setName(e.target.value)}
//                     required
//                     disabled={loading}
//                     className="w-full text-sm pl-9 pr-3 py-2.5 border border-gray-300 rounded-lg focus:ring-1 focus:ring-blue-500 focus:border-blue-500 transition-all outline-none disabled:bg-gray-100"
//                   />
//                 </div>
//               </div>

//               {/* Email Field */}
//               <div>
//                 <label className="block text-xs font-semibold text-gray-700 mb-1">
//                   Email
//                 </label>
//                 <div className="relative">
//                   <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
//                     <svg className="h-4 w-4 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                       <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
//                     </svg>
//                   </div>
//                   <input
//                     type="email"
//                     placeholder="admin@example.com"
//                     value={email}
//                     onChange={(e) => setEmail(e.target.value)}
//                     required
//                     disabled={loading}
//                     className="w-full text-sm pl-9 pr-3 py-2.5 border border-gray-300 rounded-lg focus:ring-1 focus:ring-blue-500 focus:border-blue-500 transition-all outline-none disabled:bg-gray-100"
//                   />
//                 </div>
//               </div>
//             </div>

//             {/* Password Field - Full width */}
//             <div>
//               <label className="block text-xs font-semibold text-gray-700 mb-1">
//                 Password
//               </label>
//               <div className="relative">
//                 <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
//                   <svg className="h-4 w-4 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                     <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
//                   </svg>
//                 </div>
//                 <input
//                   type={showPassword ? "text" : "password"}
//                   placeholder="••••••••"
//                   value={password}
//                   onChange={(e) => setPassword(e.target.value)}
//                   required
//                   disabled={loading}
//                   className="w-full text-sm pl-9 pr-10 py-2.5 border border-gray-300 rounded-lg focus:ring-1 focus:ring-blue-500 focus:border-blue-500 transition-all outline-none disabled:bg-gray-100"
//                 />
//                 <button
//                   type="button"
//                   onClick={() => setShowPassword(!showPassword)}
//                   className="absolute inset-y-0 right-0 pr-3 flex items-center"
//                   disabled={loading}
//                 >
//                   {showPassword ? (
//                     <svg className="h-4 w-4 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                       <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.878 9.878L6.59 6.59m7.532 7.532l3.29 3.29M3 3l3.59 3.59m0 0A9.953 9.953 0 0112 5c4.478 0 8.268 2.943 9.543 7a10.025 10.025 0 01-4.132 5.411m0 0L21 21" />
//                     </svg>
//                   ) : (
//                     <svg className="h-4 w-4 text-gray-400 hover:text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                       <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
//                       <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
//                     </svg>
//                   )}
//                 </button>
//               </div>
//             </div>

//             {/* Terms & Conditions */}
//             <div className="flex items-center">
//               <input
//                 type="checkbox"
//                 id="terms"
//                 required
//                 disabled={loading}
//                 className="h-3.5 w-3.5 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
//               />
//               <label htmlFor="terms" className="ml-2 block text-xs text-gray-700 select-none">
//                 I agree to the terms and conditions
//               </label>
//             </div>

//             {/* Submit Button */}
//             <button
//               type="submit"
//               disabled={loading}
//               className="w-full bg-gradient-to-r from-blue-600 to-blue-700 text-white text-sm py-1.5 px-4 rounded-lg font-semibold hover:from-blue-700 hover:to-blue-800 focus:outline-none focus:ring-1 focus:ring-blue-500 focus:ring-offset-1 transition-all shadow hover:shadow-md active:scale-[0.99] disabled:opacity-70"
//             >
//               {loading ? (
//                 <div className="flex items-center justify-center">
//                   <svg className="animate-spin h-4 w-4 mr-2 text-white" fill="none" viewBox="0 0 24 24">
//                     <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
//                     <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" />
//                   </svg>
//                   Creating Account...
//                 </div>
//               ) : (
//                 "Sign Up"
//               )}
//             </button>

//             {/* Admin Notice */}
//             {/* <div className="p-3 bg-blue-50 border border-blue-100 rounded-lg">
//               <div className="flex items-start">
//                 <svg className="w-3.5 h-3.5 text-blue-600 mt-0.5 mr-2 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                   <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
//                 </svg>
//                 <div>
//                   <h3 className="text-xs font-semibold text-blue-900">Admin Registration</h3>
//                   <p className="text-blue-700 text-xs mt-0.5">Authorized personnel only. All registrations are monitored.</p>
//                 </div>
//               </div>
//             </div> */}
//           </form>

//           {/* Login Link */}
//           <div className="mt-5 pt-2 border-t border-gray-200 text-center">
//             <p className="text-gray-600 text-xs">
//               Already have an account?{" "}
//               <Link 
//                 to="/login" 
//                 className="font-semibold text-blue-600 hover:text-blue-500 transition-colors text-xs"
//               >
//                 Login
//               </Link>
//             </p>
//           </div>
//         </div>

//         {/* Compact Footer */}
//         <div className="mt-4 text-center">
//           <p className="text-gray-500 text-xs">
//             © {new Date().getFullYear()} SG Overseas Admin
//           </p>
//         </div>
//       </div>
//     </div>
//   );
// }




// import React, { useState } from "react";
// import axios from "axios";
// import { useNavigate, Link } from "react-router-dom";
// import logo from "../assets/logo.png";

// export default function Signup() {
//   const [name, setName] = useState("");
//   const [email, setEmail] = useState("");
//   const [password, setPassword] = useState("");
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState("");
//   const [showPassword, setShowPassword] = useState(false);
//   const navigate = useNavigate();

//   const submit = async (e) => {
//     e.preventDefault();
//     setError("");
//     setLoading(true);
    
//     try {
//       console.log("Sending signup request with:", { name, email, password: "***" });
      
//       const response = await axios.post("https://grocerrybackend.vercel.app/api/admin/register", {
//         name,
//         email,
//         password,
//       }, {
//         headers: {
//           'Content-Type': 'application/json'
//         }
//       });

//       console.log("Signup response:", response.data);
      
//       if (response.status === 201 || response.status === 200) {
//         alert("Admin registered successfully. Please login.");
//         navigate("/login");
//       } else {
//         setError("Unexpected response from server");
//       }
//     } catch (err) {
//       console.error("Signup error details:", err);
      
//       if (err.response) {
//         console.error("Response data:", err.response.data);
//         console.error("Response status:", err.response.status);
//         console.error("Response headers:", err.response.headers);
        
//         if (err.response.status === 500) {
//           setError("Server error: Please check if the backend server is running and the database is connected");
//         } else if (err.response.data?.message) {
//           setError(err.response.data.message);
//         } else if (err.response.data?.error) {
//           setError(err.response.data.error);
//         } else {
//           setError(`Server error (${err.response.status}): ${err.response.statusText}`);
//         }
//       } else if (err.request) {
//         console.error("No response received:", err.request);
//         setError("No response from server. Please check if the backend is running on https://grocerrybackend.vercel.app");
//       } else {
//         console.error("Request setup error:", err.message);
//         setError("Failed to send request: " + err.message);
//       }
//     } finally {
//       setLoading(false);
//     }
//   };

//   // If logo import fails, use a placeholder
//   const LogoComponent = () => {
//     try {
//       return (
//         <img 
//           src={logo} 
//           alt="GrocerryAdmin Logo" 
//           className="w-full h-full object-cover rounded-full"
//         />
//       );
//     } catch (err) {
//       return (
//         <div className="w-full h-full flex items-center justify-center bg-blue-100 text-blue-600 rounded-full font-bold">
//           SG
//         </div>
//       );
//     }
//   };

//   return (
//     <div className="h-screen w-screen flex items-center justify-center p-4 bg-gradient-to-br from-blue-50 via-white to-gray-50 font-sans overflow-hidden">
//       {/* Main Container - Compact for single column */}
//       <div className="w-full max-w-md mx-auto">
        
//         {/* Logo Header */}
//         <div className="flex flex-col items-center justify-center mb-6">
//           <div className="w-16 h-16 rounded-full bg-white shadow-lg flex items-center justify-center p-1 mb-3 ring-2 ring-blue-100">
//             <LogoComponent />
//           </div>
//           <h1 className="text-xl font-bold text-gray-900 text-center">SG Overseas Admin</h1>
//           <p className="text-gray-600 text-sm mt-1 text-center">Admin Portal</p>
//         </div>

//         {/* Compact Signup Card */}
//         <div className="bg-white rounded-xl shadow-lg p-6 border border-gray-100">
          
//           {/* Form Header */}
//           <div className="text-center mb-6">
//             <h2 className="text-lg font-bold text-gray-900">Create Admin Account</h2>
//             <p className="text-gray-600 text-xs mt-1">Register to get started</p>
//           </div>

//           {/* Signup Form - Single Column */}
//           <form onSubmit={submit} className="space-y-4">
            
//             {/* Name Field */}
//             <div>
//               <label className="block text-xs font-semibold text-gray-700 mb-1">
//                 Full Name
//               </label>
//               <div className="relative">
//                 <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
//                   <svg className="h-4 w-4 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                     <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
//                   </svg>
//                 </div>
//                 <input
//                   type="text"
//                   placeholder="Enter full name"
//                   value={name}
//                   onChange={(e) => setName(e.target.value)}
//                   required
//                   disabled={loading}
//                   minLength={2}
//                   className="w-full text-sm pl-9 pr-3 py-2.5 border border-gray-300 rounded-lg focus:ring-1 focus:ring-blue-500 focus:border-blue-500 transition-all outline-none disabled:bg-gray-100"
//                 />
//               </div>
//             </div>

//             {/* Email Field */}
//             <div>
//               <label className="block text-xs font-semibold text-gray-700 mb-1">
//                 Email
//               </label>
//               <div className="relative">
//                 <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
//                   <svg className="h-4 w-4 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                     <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
//                   </svg>
//                 </div>
//                 <input
//                   type="email"
//                   placeholder="admin@example.com"
//                   value={email}
//                   onChange={(e) => setEmail(e.target.value)}
//                   required
//                   disabled={loading}
//                   className="w-full text-sm pl-9 pr-3 py-2.5 border border-gray-300 rounded-lg focus:ring-1 focus:ring-blue-500 focus:border-blue-500 transition-all outline-none disabled:bg-gray-100"
//                 />
//               </div>
//             </div>

//             {/* Password Field */}
//             <div>
//               <label className="block text-xs font-semibold text-gray-700 mb-1">
//                 Password (min. 6 characters)
//               </label>
//               <div className="relative">
//                 <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
//                   <svg className="h-4 w-4 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                     <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
//                   </svg>
//                 </div>
//                 <input
//                   type={showPassword ? "text" : "password"}
//                   placeholder="••••••••"
//                   value={password}
//                   onChange={(e) => setPassword(e.target.value)}
//                   required
//                   disabled={loading}
//                   minLength={6}
//                   className="w-full text-sm pl-9 pr-10 py-2.5 border border-gray-300 rounded-lg focus:ring-1 focus:ring-blue-500 focus:border-blue-500 transition-all outline-none disabled:bg-gray-100"
//                 />
//                 <button
//                   type="button"
//                   onClick={() => setShowPassword(!showPassword)}
//                   className="absolute inset-y-0 right-0 pr-3 flex items-center"
//                   disabled={loading}
//                 >
//                   {showPassword ? (
//                     <svg className="h-4 w-4 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                       <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.878 9.878L6.59 6.59m7.532 7.532l3.29 3.29M3 3l3.59 3.59m0 0A9.953 9.953 0 0112 5c4.478 0 8.268 2.943 9.543 7a10.025 10.025 0 01-4.132 5.411m0 0L21 21" />
//                     </svg>
//                   ) : (
//                     <svg className="h-4 w-4 text-gray-400 hover:text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                       <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
//                       <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
//                     </svg>
//                   )}
//                 </button>
//               </div>
//             </div>

//             {/* Terms & Conditions */}
//             <div className="flex items-center pt-1">
//               <input
//                 type="checkbox"
//                 id="terms"
//                 required
//                 disabled={loading}
//                 className="h-3.5 w-3.5 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
//               />
//               <label htmlFor="terms" className="ml-2 block text-xs text-gray-700 select-none">
//                 I agree to the terms and conditions
//               </label>
//             </div>

//             {/* Submit Button */}
//             <button
//               type="submit"
//               disabled={loading}
//               className="w-full bg-gradient-to-r from-blue-600 to-blue-700 text-white text-sm py-2.5 px-4 rounded-lg font-semibold hover:from-blue-700 hover:to-blue-800 focus:outline-none focus:ring-1 focus:ring-blue-500 focus:ring-offset-1 transition-all shadow hover:shadow-md active:scale-[0.99] disabled:opacity-70 mt-2"
//             >
//               {loading ? (
//                 <div className="flex items-center justify-center">
//                   <svg className="animate-spin h-4 w-4 mr-2 text-white" fill="none" viewBox="0 0 24 24">
//                     <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
//                     <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" />
//                   </svg>
//                   Creating Account...
//                 </div>
//               ) : (
//                 "Sign Up"
//               )}
//             </button>

//           </form>

//           {/* Login Link */}
//           <div className="mt-4 pt-4 border-t border-gray-200 text-center">
//             <p className="text-gray-600 text-xs">
//               Already have an account?{" "}
//               <Link 
//                 to="/login" 
//                 className="font-semibold text-blue-600 hover:text-blue-500 transition-colors text-xs"
//               >
//                 Login
//               </Link>
//             </p>
//           </div>
//         </div>

//         {/* Compact Footer */}
//         <div className="mt-4 text-center">
//           <p className="text-gray-500 text-xs">
//             © {new Date().getFullYear()} SG Overseas Admin
//           </p>
          
//         </div>
//       </div>
//     </div>
//   );
// }

import React, { useState } from "react";
import axios from "axios";
import { useNavigate, Link } from "react-router-dom";
import logo from "../assets/logo.png";

export default function Signup() {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    
    try {
      console.log("Sending signup request with:", { name, email, password: "***" });
      
      const response = await axios.post("https://grocerrybackend.vercel.app/api/admin/register", {
        name,
        email,
        password,
      }, {
        headers: {
          'Content-Type': 'application/json'
        }
      });

      console.log("Signup response:", response.data);
      
      if (response.status === 201 || response.status === 200) {
        alert("Admin registered successfully. Please login.");
        navigate("/login");
      } else {
        setError("Unexpected response from server");
      }
    } catch (err) {
      console.error("Signup error details:", err);
      
      if (err.response) {
        console.error("Response data:", err.response.data);
        console.error("Response status:", err.response.status);
        console.error("Response headers:", err.response.headers);
        
        if (err.response.status === 500) {
          setError("Server error: Please check if the backend server is running and the database is connected");
        } else if (err.response.data?.message) {
          setError(err.response.data.message);
        } else if (err.response.data?.error) {
          setError(err.response.data.error);
        } else {
          setError(`Server error (${err.response.status}): ${err.response.statusText}`);
        }
      } else if (err.request) {
        console.error("No response received:", err.request);
        setError("No response from server. Please check if the backend is running on https://grocerrybackend.vercel.app");
      } else {
        console.error("Request setup error:", err.message);
        setError("Failed to send request: " + err.message);
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 to-blue-50 flex flex-col justify-center py-12 sm:px-6 lg:px-8">
      <div className="sm:mx-auto sm:w-full sm:max-w-md">
        <div className="flex justify-center">
          <div className="w-20 h-20 rounded-full bg-white shadow-md flex items-center justify-center overflow-hidden border-2 border-blue-100">
            {logo ? (
              <img 
                src={logo} 
                alt="Logo" 
                className="w-full h-full object-cover"
              />
            ) : (
              <div className="w-full h-full flex items-center justify-center bg-blue-500 text-white text-xl font-bold">
                SG
              </div>
            )}
          </div>
        </div>
        <h2 className="mt-6 text-center text-3xl font-extrabold text-gray-900">
          Create Admin Account
        </h2>
        <p className="mt-2 text-center text-sm text-gray-600">
          SG Overseas Admin Portal
        </p>
      </div>

      <div className="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
        <div className="bg-white py-8 px-4 shadow sm:rounded-lg sm:px-10">
          {error && (
            <div className="mb-4 bg-red-50 border-l-4 border-red-400 p-4 rounded">
              <div className="flex">
                <div className="flex-shrink-0">
                  <svg className="h-5 w-5 text-red-400" viewBox="0 0 20 20" fill="currentColor">
                    <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clipRule="evenodd" />
                  </svg>
                </div>
                <div className="ml-3">
                  <p className="text-sm text-red-700">{error}</p>
                </div>
              </div>
            </div>
          )}

          <form className="space-y-6" onSubmit={submit}>
            <div>
              <label htmlFor="name" className="block text-sm font-medium text-gray-700">
                Full Name
              </label>
              <div className="mt-1">
                <input
                  id="name"
                  name="name"
                  type="text"
                  autoComplete="name"
                  required
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  disabled={loading}
                  className="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm disabled:bg-gray-100"
                  placeholder="Enter your full name"
                />
              </div>
            </div>

            <div>
              <label htmlFor="email" className="block text-sm font-medium text-gray-700">
                Email address
              </label>
              <div className="mt-1">
                <input
                  id="email"
                  name="email"
                  type="email"
                  autoComplete="email"
                  required
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  disabled={loading}
                  className="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm disabled:bg-gray-100"
                  placeholder="admin@example.com"
                />
              </div>
            </div>

            <div>
              <label htmlFor="password" className="block text-sm font-medium text-gray-700">
                Password
              </label>
              <div className="mt-1 relative">
                <input
                  id="password"
                  name="password"
                  type={showPassword ? "text" : "password"}
                  autoComplete="new-password"
                  required
                  minLength={6}
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  disabled={loading}
                  className="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm disabled:bg-gray-100 pr-10"
                  placeholder="••••••••"
                />
                <button
                  type="button"
                  className="absolute inset-y-0 right-0 pr-3 flex items-center"
                  onClick={() => setShowPassword(!showPassword)}
                  disabled={loading}
                >
                  {showPassword ? (
                    <svg className="h-5 w-5 text-gray-400 hover:text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.878 9.878L6.59 6.59m7.532 7.532l3.29 3.29M3 3l3.59 3.59m0 0A9.953 9.953 0 0112 5c4.478 0 8.268 2.943 9.543 7a10.025 10.025 0 01-4.132 5.411m0 0L21 21" />
                    </svg>
                  ) : (
                    <svg className="h-5 w-5 text-gray-400 hover:text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
                    </svg>
                  )}
                </button>
              </div>
              <p className="mt-1 text-xs text-gray-500">Password must be at least 6 characters</p>
            </div>

            <div className="flex items-center">
              <input
                id="terms"
                name="terms"
                type="checkbox"
                required
                disabled={loading}
                className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
              />
              <label htmlFor="terms" className="ml-2 block text-sm text-gray-700">
                I agree to the terms and conditions
              </label>
            </div>

            <div>
              <button
                type="submit"
                disabled={loading}
                className="w-full flex justify-center py-2.5 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-gradient-to-r from-blue-600 to-blue-700 hover:from-blue-700 hover:to-blue-800 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 disabled:opacity-50 disabled:cursor-not-allowed transition-all duration-200"
              >
                {loading ? (
                  <>
                    <svg className="animate-spin -ml-1 mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                      <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                      <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                    </svg>
                    Creating Account...
                  </>
                ) : (
                  "Sign Up"
                )}
              </button>
            </div>
          </form>

          <div className="mt-6">
            <div className="relative">
              <div className="absolute inset-0 flex items-center">
                <div className="w-full border-t border-gray-300"></div>
              </div>
              <div className="relative flex justify-center text-sm">
                <span className="px-2 bg-white text-gray-500">
                  Already have an account?
                </span>
              </div>
            </div>

            <div className="mt-6 text-center">
              <Link
                to="/login"
                className="font-medium text-blue-600 hover:text-blue-500 text-sm"
              >
                Sign in to your account
              </Link>
            </div>
          </div>

          <div className="mt-8 text-center">
            <p className="text-xs text-gray-500">
              © {new Date().getFullYear()} SG Overseas Admin. All rights reserved.
            </p>
            <p className="mt-1 text-xs text-gray-400">
              For authorized personnel only
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}